module.exports = "<div class=\"place-autocomplete-wrapper\">\n    <input type=\"text\"\n           class=\"form-control place-autocomplete\"\n           ng-model=\"model.address\"\n           placeholder=\"Search...\"\n           id=\"search\"\n           autocomplete=\"on\"\n           google-place\n           callback-fn=\"findLocationWithPlaces(googlePlaceObj)\">\n    <i class=\"fa fa-search search-icon\"></i>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/components/auto/auto.html
// module id = xLRv
// module chunks = 1 2